import type { ComponentModule } from "@/__main__/router.mjs";
import { HEROES_TO_ARTICLE_ID } from "@/game-marvel-rivals/constants-contentful.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";

const component: ComponentModule = {
  default: () => null,
  meta: () => ({
    title: ["", ""],
    description: ["", ""],
  }),
};

export const seoRoutes: BaseRoute[] = [
  ...Object.entries(HEROES_TO_ARTICLE_ID).map(([name, articleId]) => ({
    path: `/marvel-rivals/character/${encodeURIComponent(name.replace(/\s|&/g, ($1) => (!$1.trim() ? "_" : "and")))}`,
    redirect: `/marvel-rivals/article/${articleId}`,
    component, // Empty component is important
  })),
];
